import './SyncEntry.scss';

import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { Import } from '@sonar-software/sonar-imports';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import React from 'react';
import { SyncLogs } from './SyncLog';

import { Card, Collapse } from 'antd';
import { CheckCircleOutlined, StopOutlined } from '@ant-design/icons';
import {
	convertISODateToHumanReadableDate,
	isSyncCompleted,
	isSyncFailed,
	isSyncInProgress,
	isSyncWaiting
} from '@sonar-software/sonar-ts-lib';

export interface SyncEntryProps {
	onClick?: () => void;
	sync: Import;
}

export const SyncEntry: React.FC<SyncEntryProps> = ({ onClick, sync }) => {
	const { id, logs, startedOn, status } = sync;

	const humanReadableDate = convertISODateToHumanReadableDate(startedOn);
	const syncCompleted = isSyncCompleted(status);
	const syncFailed = isSyncFailed(status);
	const syncInProgress = isSyncInProgress(status);
	const syncWaiting = isSyncWaiting(status);
	const syncLoading = syncInProgress || syncWaiting;
	const displayStatus = syncLoading ? COPY_GENERIC.IN_PROGRESS : status;

	return (
		<Card
			className='sync-entry'
			key={ humanReadableDate }
			title={ humanReadableDate }
			type='inner'
			variant='borderless'>
			<Collapse
				items={ [ {
					children: <SyncLogs logs={ logs } />,
					key: id,
					label: COPY_GENERIC.LOG_FOR_SYNC(displayStatus)
				} ] }
				onChange={ onClick } />
			{ syncCompleted && <CheckCircleOutlined /> }
			{ syncFailed && <StopOutlined /> }
			{ syncLoading && <LoadingSpinner
				size='default'
				spinning /> }
		</Card>
	);
};
